import { Title } from '@jeromevvb/equinox-lib'
import RichTextBlock from '@models/projects/interfaces/richText.interface'
import FAQ from './FAQ'

interface FaqProps {
  title: string
  faqs: {
    question: string
    answer: RichTextBlock
  }[]
}

const FaqPage: React.FC<FaqProps> = ({ title, faqs }) => {
  return (
    <div className="container">
      <Title size="x-large" weight="semibold" className="mb-12 max-w-xl">
        {title}
      </Title>
      <FAQ faqs={faqs} />
    </div>
  )
}

export default FaqPage
